import * as React from 'react';
import { Segment, Table as UITable } from 'semantic-ui-react';
export var OrdersInRegister = function (_a) {
    var detail = _a.detail, children = _a.children;
    return (<div data-testid={detail.type}>
		{children}
		<Segment.Group compact>
			<UITable striped unstackable size='small'>
				<UITable.Body>
					{detail.records.map(function (record, i) { return (<UITable.Row data-testid='record' key={i}>
							<UITable.Cell>{record.dateOfPublication}</UITable.Cell>
							<UITable.Cell>{record.supplier}</UITable.Cell>
							<UITable.Cell>
								<a href={record.url}>{record.url}</a>
							</UITable.Cell>
						</UITable.Row>); })}
				</UITable.Body>
			</UITable>
		</Segment.Group>
	</div>);
};
